import { defer, Observable, OperatorFunction, Subject } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

export function prepare<T>(callback: () => void): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    defer(() => {
      callback();
      return source;
    });
}

// Have nice loading indicators
// First in your class
//    loading$ = new Subject<boolean>()
// Then in your observable
//    .pipe(indicate(this.loading$))
export function indicate<T>(indicator: Subject<boolean>): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      prepare(() => indicator.next(true)),
      finalize(() => indicator.next(false))
    );
}

// best used with watchQueries, indicateAround(this.loading$, switchMap(this.service.call))
export function indicateAround<T, V>(
  indicator: Subject<boolean>,
  loader: OperatorFunction<T, V>
): (source: Observable<T>) => Observable<V> {
  return (source: Observable<T>): Observable<V> =>
    source.pipe(
      tap(() => indicator.next(true)),
      loader,
      tap(() => indicator.next(false))
    );
}
